export default function FormChooseDe(props) {
    return (
        <div style={{ width: '100%',  height: '10px'}}></div>
    )
}
